
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AdministratorPlayersProfileTipsListFormUpdate} from "@/models/app/administrator/players/profile/tips/list/form/update";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
} from "element-plus";
import {Edit} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";
import {ResponseIndex} from "@/models/response";

@Options({
  props: [
    "tip",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    Edit,
  },
})
export default class AdministratorPlayersProfileTipsListFormUpdateIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  tip: AdministratorPlayersProfileTipsListFormUpdate = new AdministratorPlayersProfileTipsListFormUpdate();

  formData: AdministratorPlayersProfileTipsListFormUpdate = new AdministratorPlayersProfileTipsListFormUpdate();
  formDataRules = {
    content: {
      message: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
    },
  };

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/tips/update",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getTips');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.tip;
  }

  resetFormData(): void {
    this.formData = new AdministratorPlayersProfileTipsListFormUpdate();
  }

  updated(): void {
    this.setFormData();
  }
}
